import React, { useState } from 'react';
import {
  ConfigProvider,
  List,
  LoadingTip,
  Popover,
  SearchBox,
} from 'tea-component';
import useGameList from '../../hooks/useGameList';
import RenderGameIcon from '../../components/RenderImg/renderGameIcon';
import RegionCountryItem from '../../components/Snippets/RegionCountryItem';
import { useIntl } from 'umi';
import './index.scss';

let timeout: any;

export default function RightSearchBox({ sourceType, onSearch }: any) {
  // 是否显示检索列表
  const [showQueryList, setShowQueryList] = useState(false);
  // 当前查询的内容
  const [searchValue, setSearchValue] = useState('');
  // 当前查询的内容
  const [searchId, setSearchId] = useState('');
  const [requestSearchValue, setRequestSearchValue] = useState('');
  const { formatMessage } = useIntl();
  const { games, loading } = useGameList({
    edition_unified_id: searchId,
    entity_name: requestSearchValue,
    source_type: sourceType,
    otherParams: {
      need_mobile_editions: false,
      need_country_publisher: true,
    },
  });

  const debounce = (func: any, delay: number) => {
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      func();
    }, delay);
  };

  return (
    <div className="dbo-gamelist-search-wrapper">
      <ConfigProvider locale="en">
        <Popover
          placement="bottom"
          visible={showQueryList}
          overlayClassName="dbo-game-queryList"
          popupContainer={() =>
            document.querySelector('.dbo-gamelist-search-wrapper') as any
          }
          overlay={
            loading ? (
              <LoadingTip
                loadingText=""
                className="dbo-game-queryList-loding"
              />
            ) : games.length > 0 ? (
              <List type="option" className="dbo-queryList-box-list">
                {games.map((item) => {
                  return (
                    <List.Item
                      key={item.edition_unified_id}
                      onClick={() => {
                        console.log(item);
                        setRequestSearchValue(item.entity_name);
                        setSearchValue(item.entity_name);
                        setSearchId(item.edition_unified_id);
                        onSearch(item.entity_name, item.edition_unified_id);
                        setShowQueryList(false);
                      }}
                    >
                      <div className="dbo-queryList-box">
                        <RenderGameIcon
                          gameInfo={item}
                          className="dbo-queryList-box-img"
                        ></RenderGameIcon>
                        <div className="dbo-queryList-box-context">
                          <div className="dbo-queryList-box-title">
                            {item.entity_name}
                          </div>
                          <div className="dbo-queryList-box-flex">
                            <RegionCountryItem
                              showText={false}
                              iconClassName="dbo-queryList-box-country"
                              market={item.country}
                            ></RegionCountryItem>
                            <div className="dbo-queryList-box-desc">
                              <span>{item.publisher}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </List.Item>
                  );
                })}
              </List>
            ) : (
              <div className="dbo-game-queryList-erry">
                {formatMessage({ id: 'sorry, no result found.' })}
              </div>
            )
          }
        >
          <SearchBox
            placeholder={formatMessage({
              id: 'Search any game in the following table.',
            })}
            style={{ width: 390 }}
            value={searchValue}
            onClear={() => {
              setShowQueryList(false);
              setSearchValue('');
              setSearchId('');
              onSearch('', '');
            }}
            onBlur={() => {
              setTimeout(() => {
                setShowQueryList(false);
              }, 500);
            }}
            onFocus={() => {
              if (searchValue) {
                setShowQueryList(true);
              }
            }}
            onChange={(value) => {
              setSearchValue(value);
              const queryAllFn = () => {
                setRequestSearchValue(value);
              };
              debounce(queryAllFn, 500);

              setTimeout(() => {
                setShowQueryList(value !== '');
              }, 500);
            }}
            onSearch={(val) => {
              setShowQueryList(false);
              const value = val?.replace(/(^\s*)|(\s*$)/g, '') || '';
              setSearchValue(value);
              setRequestSearchValue(value);
              setSearchId('');
              onSearch(value, '');
            }}
          />
        </Popover>
      </ConfigProvider>
    </div>
  );
}
